const OpenIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 208.402 208.402">
      <path
        id="add"
        d="M189.795,85.594H126.53a3.722,3.722,0,0,1-3.721-3.721V18.607a18.607,18.607,0,0,0-37.215,0V81.872a3.722,3.722,0,0,1-3.721,3.721H18.607a18.607,18.607,0,0,0,0,37.215H81.872a3.722,3.722,0,0,1,3.721,3.721v63.265a18.607,18.607,0,1,0,37.215,0V126.53a3.722,3.722,0,0,1,3.721-3.721h63.265a18.607,18.607,0,1,0,0-37.215Zm0,0"
        fill="#b2b2b2"
      />
    </svg>
  );
};
export default OpenIcon;
